<bw-action-card-legacy
  (ctaClicked)="routeToCredit()"
  [cardConfig]="creditSetupActionCardConfig">
</bw-action-card-legacy>
